export default (theme) => ({
    root: {
        height: '100%',
        width: '100%',
        position: 'relative',
        boxSizing: 'border-box',
        '& *': {
            boxSizing: 'border-box',
        },
    },
    frame: {
        display: 'flex',
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: theme.colors.grey[50],
        border: `1px solid ${theme.colors.grey[100]}`,
    },
    document: {
        position: 'relative',
        margin: 'auto',
    },
    loader: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    wrap: {
        position: 'relative',
    },
    page: {
        position: 'relative',
        minWidth: 'min-content',
        minHeight: 'min-content',
        backgroundColor: theme.colors.primary.white,
    },
    canvas: {
        display: 'block',
        margin: '32px auto',
        boxShadow:
            '0px 8px 10px rgba(39, 60, 80, 0.14), 0px 3px 14px rgba(39, 60, 80, 0.12), 0px 4px 5px rgba(39, 60, 80, 0.2)',
    },
    exitFullscreen: {
        position: 'absolute',
        top: 16,
        left: 16,
        zIndex: 2,
    },
    toolbar: {
        boxSizing: 'border-box',
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        backgroundColor: theme.colors.textLight.primary,
        color: theme.colors.primary.white,
        borderRadius: 8,
        height: 56,
        position: 'absolute',
        bottom: 16,
        left: '50%',
        zIndex: 2,
        transform: 'translateX(-50%)',
    },
    toolbarItems: {
        display: 'flex',
        flexFlow: 'row nowrap',
        '&:not(:first-child)': {
            marginLeft: 32,
        },
    },
    toolbarItem: {
        fontFamily: theme.typography.fontFamily,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: '0.15px',
        whiteSpace: 'nowrap',
        '&:not(:first-child)': {
            marginLeft: 16,
        },
    },
    toolbarIcon: {
        color: theme.colors.primary.white,
        transition: 'all 0.2s linear',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.5,
        },
    },
});
